import postFetcherQuiet from 'api/utils/postFetcherQuiet';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { LegacyOrderData } from 'types/legacyDashboard';

interface UsePurchasePhoneNumberPreviewProps {
  organizationId?: OrgId;
  deviceId?: DeviceId;
  country?: string;
  areaCode?: string;
}

interface PurchasePhoneNumberPreviewBody {
  areacode?: string;
  country: string;
}

export interface PurchasePhoneNumberPreviewResult {
  success: boolean;
  order_data: LegacyOrderData;
  data: null;
  error?: string;
}

export interface PurchasePhoneNumberPreviewResultError {}

const usePurchasePhoneNumberPreview = ({
  organizationId,
  deviceId,
  country,
  areaCode,
}: UsePurchasePhoneNumberPreviewProps) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}`, preview: '1' });
  const url =
    deviceId && organizationId
      ? `${process.env.VITE_API_ROOT}/devices/${deviceId}/addnumber?${queryParams}`
      : null;

  const key: { url: string; body: PurchasePhoneNumberPreviewBody } | null =
    url && country
      ? {
          url,
          body: {
            areacode: areaCode,
            country,
          },
        }
      : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    PurchasePhoneNumberPreviewResult,
    PurchasePhoneNumberPreviewResultError
  >(key, postFetcherQuiet);

  const phoneNumberCost: string | undefined = useMemo(
    () => data?.order_data?.total_cost ?? undefined,
    [data]
  );

  return {
    phoneNumberCost,
    error: error || data?.error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default usePurchasePhoneNumberPreview;
